import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReveniIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.3295 5.88256V7.07999C12.3295 10.0118 6.54327 14.6669 4.20207 14.6667C3.73122 14.6667 3.33334 14.2696 3.33334 13.7995V12.6024C3.33334 11.9957 4.02787 11.3179 4.84887 10.5165C5.76152 9.62562 6.83053 8.58216 7.27561 7.31426C6.90658 6.52032 6.07129 6.04506 5.31427 5.61436C4.5238 5.16458 3.81867 4.76336 3.81867 4.09855V2.90113C3.81867 2.45819 4.19064 2 4.813 2C5.9365 2 12.3295 2.92456 12.3295 5.88256ZM11.7095 5.88269C11.7095 3.59433 5.95283 2.62526 4.81465 2.62526C4.58184 2.62526 4.44207 2.77212 4.4422 2.90126C4.4422 3.18867 4.93004 3.46916 5.54491 3.82273C6.59282 4.42529 8.00972 5.24005 8.00972 6.66265C8.00972 8.26469 6.38371 9.88045 5.19152 11.0651C4.50154 11.7507 3.95688 12.292 3.95688 12.6026C3.95688 12.7292 4.07313 12.8446 4.20372 12.8446C6.19404 12.8446 11.7095 8.42118 11.7095 5.88269Z",
		fill: "#111111"
	})
});
export default SvgReveniIcon;
